<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cooling Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (sourceEftSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Source Entering Fluid Temp:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="sourceEftSelection.Value"
                (change)="textSelectionChanged(sourceEftSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(sourceEftSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadEftSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Entering Fluid Temp:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="loadEftSelection.Value"
                (change)="textSelectionChanged(loadEftSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(loadEftSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
